import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redirect',
  template: `<p>Redirecting...</p>`,
})
export class RedirectComponent implements OnInit {
     domain = window.location.hostname;
  ngOnInit() {
    window.location.href = '/demo/dashboard.html';
  }
}



// WEBPACK FOOTER //
// /app/src/app/RedirectComponent.ts